var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeDown = function SvgSizeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0v3h5v12h3V3h5V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5h9v3h-3v7h-3V8h-3z"
  })));
};
export default SvgSizeDown;